import { createI18n } from 'vue-i18n';
import elMessages from '../locales/el';
import enMessages from '../locales/en';

export const i18n = createI18n({
  legacy: false,
  locale: getBrowserLocale() || 'en', // Default locale
  fallbackLocale: 'en', // Fallback locale
  messages: {
    en: enMessages,
    el: elMessages,
  },
});

function getBrowserLocale() {
  const navigatorLocale =
    navigator.languages !== undefined ? navigator.languages[0] : navigator.language;

  if (!navigatorLocale) {
    return undefined;
  }

  const trimmedLocale = navigatorLocale.trim().split(/-|_/)[0];

  return trimmedLocale;
}

export type Locale = keyof typeof i18n.global.messages.value;
